import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

class ErrorModal extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			modal: false,
			text: "",
			title: ""
		};
	}

	show(value) {
		this.setState({
			title: "",
			text: value,
			modal: true
		});
	}

	hide(value) {
		this.setState({
			modal: false
		})
	}

	render() {
		return (
			<div>
				<Modal isOpen={this.state.modal} toggle={this.hide} className={this.props.className}>
					<ModalHeader>Erreur</ModalHeader>
					<ModalBody>
						{this.state.text.split('\n').map((item, key) => {
							return <span key={key}>{item}<br/></span>
						})}
					</ModalBody>
					<ModalFooter>
						<Button color="secondary" onClick={() => this.hide()}>Revenir au formulaire</Button>
					</ModalFooter>
				</Modal>
			</div>
		);
	}
}


export default ErrorModal;



// WEBPACK FOOTER //
// ./src/modals/ErrorModal.jsx